import { useTranslation } from 'react-i18next'

import { useScreen } from '../../../hooks'
import { MoneyInput } from '../../Currency'
import { FormikField, getFormikFormFieldErrorProps } from '../../Formik'
import { LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT } from '../RentalPortalListing.constants'

function RentalPortalListingDepositAmountField({ isLoading }) {
  const { t } = useTranslation()

  const { isMobileScreenSize } = useScreen()

  return (
    <FormikField
      Component={MoneyInput}
      controlProps={{ borderless: !isMobileScreenSize }}
      fieldComponentProps={{
        isLoading,
        label: `${t('RentalPortal.ListingFormDepositAmountLabelKey')}:`,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      name={LISTING_FORM_FIELD_NAME_DEPOSIT_AMOUNT}
      placeholder={t('RentalPortal.ListingFormDepositAmountPlaceholderKey')}
    />
  )
}

export default RentalPortalListingDepositAmountField
